import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BackButton({ route }: { route?: string }) {
    const navigate = useNavigate();

    return (
        <button
            className="flex items-center gap-2 pb-2 text-sm"
            onClick={() => (route ? navigate(route) : navigate(-1))}
        >
            <ArrowLeftIcon className="h-4 w-4" />
            Back
        </button>
    );
}
